import { Component, Injectable, Input, Output, EventEmitter, OnChanges, OnInit, OnDestroy, SimpleChanges, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Subscription } from "rxjs";
import { Utils } from "../../utils/utils";
import { DialogService } from "../../services/dialog.service";
import { ProgressBarMode } from "@angular/material/progress-bar";
import { ThemePalette } from "@angular/material/core";

@Injectable()

@Component({
    selector: "alert-confirm",
    templateUrl: './alert-confirm.component.html',
    styleUrls: ['./alert-confirm.component.less',
        '../../style/form.component.less',
        '../../style/buttons/rulebook-framework/framework-buttons.less'],
    standalone: false
})

export class AlertConfirmComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    readonly SUCCESS: number = Utils.getSuccessValue();
    readonly ERROR: number = Utils.getErrorValue();
    readonly WARNING: number = Utils.getWarningValue();
    readonly INFO_BACKGROUND: number = Utils.getInfoBackgroundValue();
    readonly CONFIRM: number = Utils.getConfirmValue();

    @Input('title') title: string = "";
    @Input('message') message: string = "";
    @Input('type') type: number = this.SUCCESS;
    @Input('className') classname: string = "";
    @Input('items') items: string[] = [];
    @Input('progressValue') progressValue: number = -1;
    @Input('showTypeIcon') showTypeIcon: boolean = true;
    @Input('text_icon_items') textIconItems: TextIconItem[] = [];
    @Input('messageColor') messageColor: string = 'white';
    @Input('messageFontSize') messageFontSize: number = 14;

    @ViewChild('alertConfirm') alertConfirm?: ElementRef;

    readonly mode: ProgressBarMode = "determinate"
    readonly color: ThemePalette = "primary"

    @Output() readonly clickOk = new EventEmitter<any>();
    @Output() readonly clickYes = new EventEmitter<any>();
    @Output() readonly clickNo = new EventEmitter<any>();

    private visibilitySubscription?: Subscription;

    constructor(
        private readonly activatedRoute: ActivatedRoute
        , private readonly router: Router
        , private readonly http: HttpClient
        , private readonly dialog: DialogService
        , private readonly cdRef: ChangeDetectorRef
    ) {

    }

    ngOnInit() {
        this.visibilitySubscription = this.dialog.visibilityChanged$.subscribe(isShown => {
            if (isShown) {
                //defer so the 'dialog' show class has been applied and layout/offsetHeight is accurate
                setTimeout(() => this.repositionDialog());
            }
        });
    }

    ngOnDestroy() {
        this.visibilitySubscription?.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes['type']) {
            const previousValue = changes['type'].previousValue;
            const currentValue = changes['type'].currentValue;
            if (previousValue === 4 && currentValue !== 4) {
                this.progressValue = -1;
            }
        }
    }

    ngAfterViewInit() {
        this.repositionDialog();
    }

    private repositionDialog() {
        if (!this.alertConfirm) {
            return;
        }
        const nativeElement = this.alertConfirm.nativeElement;
        nativeElement.scrollTop = -nativeElement.scrollHeight;

        //regardless of the element's actual position scheme (fixed/absolute) or which
        //ancestor establishes its containing block, scrollIntoView scrolls any scrollable
        //ancestor containers so the element ends up centered in the visible viewport.
        nativeElement.scrollIntoView({ block: 'center', inline: 'center' });
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    onNo() {
        this.clickNo.emit();
    }

    onOk() {
        this.clickOk.emit();
    }

    onYes() {
        this.clickYes.emit();
    }
}